<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line class="pt-0">
        <v-list-item-title class="headline">
          {{
            $t('administration.profils.autorisationAgil.title')
          }}</v-list-item-title
        >
        <v-list-item-subtitle>{{
          $t('administration.profils.autorisationAgil.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        fixed-header
        height="70vh"
        disable-pagination
        disable-sort
        hide-default-footer
        dense
      >
        <template #item="{item}">
          <tr>
            <td v-for="header in headers" :key="header.value">
              <span v-if="header.type === 'header'">
                {{ item[header.value] }}
              </span>
              <span
                class="d-flex justify-center"
                v-else-if="!item[header.value].revoquable"
              >
                <v-icon color="primary">mdi-lock</v-icon>
                <v-icon color="transparent">mdi-checkbox-blank</v-icon>
              </span>
              <span v-else class="d-flex justify-center">
                <v-simple-checkbox
                  v-model="item[header.value].checked"
                  color="primary"
                  @input="toggle(item[header.value])"
                />
                <v-icon v-if="item[header.value].operation" color="accent"
                  >mdi-alert-decagram</v-icon
                >
                <v-icon v-else color="transparent">mdi-checkbox-blank</v-icon>
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="quit">
        {{ $t('button.quit') }}
      </v-btn>
      <v-btn color="primary" @click="save()">
        {{ $t('button.save') }}
      </v-btn>

      <v-dialog v-model="confirmQuit" persistent width="600px">
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{
              $t('administration.profils.autorisationAgil.confirmQuit.title')
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="body-1">
            <p class="pt-4">
              {{
                $t(
                  'administration.profils.autorisationAgil.confirmQuit.content',
                )
              }}
            </p>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="abortQuit()">
              {{ $t('button.no') }}
            </v-btn>
            <v-btn color="primary" @click="doQuit()">
              {{ $t('button.yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmSave" persistent width="600px">
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{
              $t('administration.profils.autorisationAgil.confirmSave.title')
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="body-1">
            <p class="pt-4">
              {{
                $t(
                  'administration.profils.autorisationAgil.confirmSave.content',
                )
              }}
            </p>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="abortSave()">
              {{ $t('button.no') }}
            </v-btn>
            <v-btn color="primary" @click="doSave()">
              {{ $t('button.yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash';
import toasted from '@/utils/toasted';
export default {
  provide() {
    return {
      $vroot: this.$v,
    };
  },
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
  },

  beforeRouteEnter: (to, from, next) => {
    next(vm => vm.getEnumsandValue());
  },
  data() {
    return {
      enums: {
        columns: [],
        rows: [],
      },
      headers: [],
      rowsMap: new Map(),

      items: [],
      initialItems: [],

      /* booleans pour l'affichage des dialogs */
      dataModified: false,
      confirmSave: false,
      confirmQuit: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  watch: {},
  methods: {
    // Charge les entêtes (lignes et colonnes)
    getEnumsandValue() {
      this.$api('enums/autorisation-agil')
        .get()
        .then(response => {
          const body = response.body;
          this.enums.columns = body.typesAccesAgil;
          this.enums.rows = body.privilegesAgil;

          // On initialise les colonnes
          this.headers = [
            {
              type: 'header',
              value: 'libelle',
              text: this.$t(
                'administration.profils.autorisationAgil.table.headers.libelle',
              ),
            },
            /*
            {
              type: 'header',
              value: 'id',
              text: this.$t('administration.profils.autorisationAgil.table.headers.id'),
            },
            */
          ];

          this.enums.columns.forEach(t => {
            this.headers.push({
              value: t.code,
              text: t.libelle,
              align: 'center',
            });
          });

          // On initialise les lignes
          this.rowsMap.clear();
          this.items = [];
          this.initialItems = [];

          this.enums.rows.forEach(p => {
            var row = {};
            // Tous d'abord l'id et le libellé
            row.id = p.code;
            row.libelle = p.libelle;
            // Puis la matrice
            this.enums.columns.forEach(t => {
              row[t.code] = {
                id: null,
                idTypeAccesAgil: t.id,
                idPrivilegeAgil: p.id,
                revoquable: true,
                initialChecked: false,
                checked: false,
                operation: null,
              };
            });
            this.items.push(row);
            this.rowsMap.set(p.code, row);
          });

          this.$api('administration/autorisation-agil')
            .get()
            .then(response => {
              const body = response.body;
              body.forEach(a => {
                var cell = this.rowsMap.get(a.codePrivilegeAgil)[
                  a.codeTypeAccesAgil
                ];
                cell.id = a.id;
                cell.idTypeAccesAgil = a.idTypeAccesAgil;
                cell.idPrivilegeAgil = a.idPrivilegeAgil;
                cell.revoquable = a.revoquable;
                cell.initialChecked = true;
                cell.checked = true;
                this.init();
              });
            });
        });
    },

    // Charge les valeurs du Back et prépare l'affichage

    // Pour vérifier ensuite si les données ont changé
    init() {
      this.initialItems = JSON.parse(JSON.stringify(this.items));
    },

    // Détecte le changement de valeur d'une checkbox
    toggle(cb) {
      if (cb) {
        if (cb.checked != cb.initialChecked) {
          if (cb.checked) {
            cb.operation = 'check';
          } else {
            cb.operation = 'uncheck';
          }
        } else {
          cb.operation = null;
        }
      }
    },

    // Quitter
    quit() {
      // On quite et on retourne d'où on vient
      if (!_.isEqual(this.items, this.initialItems)) {
        this.confirmQuit = true;
      } else {
        this.doQuit();
      }
    },
    abortQuit() {
      this.confirmQuit = false;
    },
    doQuit() {
      this.$router.replace(this.returnRoute);
    },

    // Save
    save() {
      if (!_.isEqual(this.items, this.initialItems)) {
        this.confirmSave = true;
      } else {
        toasted.info(
          'administration.profils.autorisationAgil.results.save.noop',
        );
      }
    },
    abortSave() {
      this.confirmSave = false;
    },
    doSave() {
      this.confirmSave = false;
      let updatedItems = [];
      this.items.forEach(p => {
        this.enums.columns.forEach(t => {
          var a = p[t.code];
          if (a && a.checked != a.initialChecked) {
            updatedItems.push({
              id: a.id,
              idTypeAccesAgil: a.idTypeAccesAgil,
              idPrivilegeAgil: a.idPrivilegeAgil,
              revoquable: a.revoquable,
              checked: a.checked,
            });
          }
        });
      });
      this.$api('administration/autorisation-agil')
        .post(updatedItems)
        .then(
          result => {
            if (
              (Array.isArray(result.creationError) &&
                result.creationError.length > 0) ||
              (Array.isArray(result.deletionError) &&
                result.deletionError.length > 0)
            ) {
              toasted.error(
                'administration.profils.autorisationAgil.results.save.error',
              );
            } else {
              toasted.info(
                'administration.profils.autorisationAgil.results.save.success',
              );
              this.getEnumsandValue();
            }
          },
          () => {
            toasted.error(
              'administration.profils.autorisationAgil.results.save.error',
            );
          },
        );
    },
  },
};
</script>
